import React, { useRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import { NavLink, Link } from 'react-router-dom';
import { gsap } from 'gsap';
import OrderOnlineModal from './OrderOnlineModal';

const Wrap = styled.header`
  position: sticky;
  top: 0;
  z-index: 40;
  background: #ffffff;
  border-bottom: 1px solid #eee;
`;

const Inner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
`;

const Brand = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
`;

const Logo = styled.img`
  width: 110px;
  height: auto;
`;

const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: 22px;
`;

const NavA = styled(NavLink)`
  color: #ff761a;
  font-weight: 700;
  text-decoration: none;
  position: relative;
  transform-origin: center;
  &.active::after {
    content: '';
    position: absolute;
    left: 0; right: 0; bottom: -6px;
    height: 2px; background: #ff761a;
  }
`;

const OrderBtn = styled.button`
  color: #ff761a;
  font-weight: 700;
  background: transparent;
  border: none;
  cursor: pointer;
  position: relative;
`;


export default function HeaderNav() {
  const homeRef = useRef(null);
  const menuRef = useRef(null);
  const orderRef = useRef(null);
  const refs = [homeRef, menuRef, orderRef];
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const cleanups = refs.map(r => {
      const el = r.current;
      if (!el) return () => {};
      const onEnter = () => gsap.to(el, { scale: 1.06, duration: 0.15, ease: 'power2.out' });
      const onLeave = () => gsap.to(el, { scale: 1, duration: 0.15, ease: 'power2.out' });
      const onDown = () => gsap.to(el, { scale: 0.96, duration: 0.08, ease: 'power2.in' });
      const onUp = () => gsap.to(el, { scale: 1.04, duration: 0.12, ease: 'power2.out' });
      el.addEventListener('mouseenter', onEnter);
      el.addEventListener('mouseleave', onLeave);
      el.addEventListener('mousedown', onDown);
      el.addEventListener('mouseup', onUp);
      return () => {
        el.removeEventListener('mouseenter', onEnter);
        el.removeEventListener('mouseleave', onLeave);
        el.removeEventListener('mousedown', onDown);
        el.removeEventListener('mouseup', onUp);
      };
    });
    return () => cleanups.forEach(fn => fn());
  }, []);

  return (
    <Wrap>
      <Inner>
        <Brand to="/">
          <Logo src="/LOGO.jpg" alt="Local Poké" />
        </Brand>
        <Nav>
          <NavA ref={homeRef} to="/" end>Home</NavA>
          <NavA ref={menuRef} to="/menu">Menu</NavA>
          <OrderBtn ref={orderRef} onClick={() => setOpen(true)}>Order Online</OrderBtn>
        </Nav>
      </Inner>
      <OrderOnlineModal open={open} onClose={() => setOpen(false)} />
    </Wrap>
  );
}
